import { MonoDatePickerWithDefaultPreset } from 'components/shared/DatePicker/MonoDatePicker';
import { FC, useCallback } from 'react';

import type { ColumnProps } from './model';

interface DateColumnProps extends ColumnProps<Nullable<string>> {
  isClearable: boolean;
  hasErrors?: boolean;
  isDisabled?: boolean;
  align?: 'start' | 'end' | 'left' | 'right';
  e2e?: string;
}

const getDatePart = (dateTimeString: Nullable<string>) =>
  dateTimeString !== null ? dateTimeString.split('T')[0] : null;

export const GridDateColumn: FC<DateColumnProps> = ({
  value,
  id,
  setCellValue,
  isClearable,
  hasErrors,
  isDisabled,
  e2e,
  align = 'start',
}) => {
  const date = getDatePart(value);

  const onChange = useCallback(
    (val: any) => {
      setCellValue(id, val);
    },
    [id, setCellValue],
  );
  return (
    <MonoDatePickerWithDefaultPreset
      id={e2e ?? 'col-' + id}
      value={date}
      onChange={onChange}
      allowWeekend
      isClearable={isClearable}
      disabled={isDisabled ?? false}
      align={align}
      hasError={hasErrors}
    />
  );
};

GridDateColumn.displayName = 'GridDateColumn';
